import React from 'react';

export type RouteLoadingVariant = 'content' | 'dashboard';

interface RouteLoadingSkeletonProps {
  variant?: RouteLoadingVariant;
}

const SkeletonBlock: React.FC<{ className: string }> = ({ className }) => (
  <div className={`animate-pulse rounded-md bg-[var(--qcl-bg)] ${className}`} />
);

const RouteLoadingSkeleton: React.FC<RouteLoadingSkeletonProps> = ({ variant = 'content' }) => {
  if (variant === 'dashboard') {
    return (
      <div className="mx-auto w-full max-w-[1180px] px-4 py-4 md:px-7">
        <SkeletonBlock className="mb-4 h-8 w-64" />
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <SkeletonBlock className="h-44 w-full" />
          <SkeletonBlock className="h-44 w-full" />
          <SkeletonBlock className="h-44 w-full xl:block md:col-span-2 xl:col-span-1" />
        </div>
        <SkeletonBlock className="mt-4 h-[360px] w-full" />
      </div>
    );
  }

  return (
    <div className="mx-auto w-full max-w-[980px] px-4 py-6 md:px-7">
      <SkeletonBlock className="mb-4 h-7 w-56" />
      <SkeletonBlock className="mb-3 h-5 w-full" />
      <SkeletonBlock className="mb-3 h-5 w-[92%]" />
      <SkeletonBlock className="mb-6 h-5 w-[78%]" />
      <SkeletonBlock className="h-48 w-full" />
    </div>
  );
};

export default RouteLoadingSkeleton;
